import styled, { keyframes } from 'styled-components';
import color from '../../../config/colors.json';

const pulseAnimation = keyframes`
    0% {
        box-shadow: 0 0 0 0 ${`${color.lightRed}50`};
        border-radius: 15px;
    }
    70% {
        box-shadow: 0 0 0 5px ${`${color.lightRed}00`};
        border-radius: 15px;
    }
    100% {
        box-shadow: 0 0 0 0 ${`${color.lightRed}00`};
        border-radius: 15px;
    }
`;

export const ProgressComponent = styled.div`
    flex-direction: column;
    width: 100%;
    margin-bottom: 30px;
`;

export const Progress = styled.div`
    position: relative;
    display: flex;
    z-index: 2;
`;
export const ProgressBar = styled.div`
    position: absolute;
    width: ${({ totalSteps, step }) => `calc(100% / ${totalSteps} * ${(step)})`};
    background: ${color.lightRed};
    transition: width 500ms ease-in-out;
    height: 3px;
    animation: ${pulseAnimation} 2s infinite;
`;
export const ProgressTrack = styled.div`
    position: absolute;
    height: 3px;
    width: calc(100%);
    background-color: ${color.lightGrey2};
    z-index: -1;
`;
export const SubTitle = styled.h2`
    text-align: left;
    font-family: Poppins, Helvetica, Arial, sans-serif;
    font-size: 12px;
    letter-spacing: 0;
    color: ${color.green};
    opacity: 1;
`;
export const Title = styled.h1`
    text-align: left;
    font-family: Poppins, Helvetica, Arial, sans-serif;
    font-size: 15px;
    letter-spacing: 0;
    font-weight: 600;
    color: ${color.lightRed};
    opacity: 1;
    margin-bottom: 7px;
`;
